module.exports = __webpack_public_path__ + "img/r-3-btn.658745d8.png";